var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Isitme(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "air-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 155.6 106.5"
    },
    xmlSpace: "preserve",
    viewBox: "26.9 1.7 101.8 103.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " \t.st0{fill:none;stroke:#000000;stroke-width:0.1;stroke-miterlimit:10;} \t.st1{fill:none;stroke:#000000;stroke-width:3.4;stroke-miterlimit:10;} ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1 svg-elem-2",
    x1: 40.9,
    y1: 3.5,
    x2: 40.9,
    y2: 41.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1 svg-elem-3",
    x1: 48.3,
    y1: 3.5,
    x2: 48.3,
    y2: 41.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1 svg-elem-4",
    x1: 111.7,
    y1: 20.7,
    x2: 111.7,
    y2: 49.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1 svg-elem-5",
    x1: 111.7,
    y1: 3.4,
    x2: 111.7,
    y2: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-6",
    d: "M55.5,95.6H33.9c-2.9,0-5.3-2.4-5.3-5.3V47.1c0-2.9,2.4-5.3,5.3-5.3h21.6c2.9,0,5.3,2.4,5.3,5.3v43.2  C60.7,93.3,58.4,95.6,55.5,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-7",
    d: "M111.4,95.6H89c-2.7,0-4.9-2.2-4.9-4.9v-36c0-2.7,2.2-4.9,4.9-4.9h22.4c2.7,0,4.9,2.2,4.9,4.9v36  C116.2,93.5,114.1,95.6,111.4,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-8",
    d: "M95.1,14.3v25.5c0,2.7-2.2,4.9-4.9,4.9H72.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-9",
    d: "M72.9,35.6v32.3c0,2.7-2.2,4.9-4.9,4.9h-5.8c-0.3,0-0.7,0-1-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-10",
    d: "M127,21.7v36.9c0,2.7-2.2,4.9-4.9,4.9h-4.9c-0.3,0-0.5,0-0.9-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-11",
    d: "M127,56.3V19.3c0-2.7-2.2-4.9-4.9-4.9h-4.9c-0.3,0-0.5,0-0.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-12",
    d: "M57.2,42.3v-8.1c0-2.7,2.2-4.9,4.9-4.9h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-13",
    d: "M72.5,22.8v-3.3c0-2.7,2.2-4.9,4.9-4.9h29.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-14",
    d: "M99.3,95.2v1.4c0,3.6-2.2,6.5-4.9,6.5h-8.1h2.2h-8.1c-2.7,0-4.9-2.9-4.9-6.5v-1.4l0,2.1v-4.6  c0-2.7-2.9-4.9-6.5-4.9h-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-15",
    d: "M75.7,36.2h-6.1c-0.8,0-1.4-0.6-1.4-1.4V24.2c0-0.8,0.6-1.4,1.4-1.4h6.1c0.8,0,1.4,0.6,1.4,1.4v10.6  C77,35.6,76.4,36.2,75.7,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-16",
    d: "M114.7,20.7h-6.1c-0.8,0-1.4-0.6-1.4-1.4V8.7c0-0.8,0.6-1.4,1.4-1.4h6.1c0.8,0,1.4,0.6,1.4,1.4v10.6  C116.1,20.1,115.5,20.7,114.7,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-17",
    d: "M44.7,59.9l-7.4,8.7c-2.7,3.9,0.7,8.7,6.1,8.7h2.9c5.4,0,8.8-4.8,6.1-8.7L44.7,59.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1 svg-elem-18",
    d: "M90.7,84.4c0,0-4.3-5.7,1.9-14.2c2.9,4.1,2.9,4.1,2.9,4.1l0,0l5-7.4l5.2,7.4l0,0c0,0,0,0,2.9-4.1  c6.2,8.5,1.9,14.2,1.9,14.2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Isitme);
export default __webpack_public_path__ + "static/media/3.isitme.1f2a980dda9873317439fcffbfffb038.svg";
export { ForwardRef as ReactComponent };